import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LogTransport, LogEntry, LogLevel } from '../interfaces/logger.interface';
import { LogFormatterUtil } from '../utils/log-formatter.util';

@Injectable()
export class ConsoleTransport implements LogTransport {
  name = 'console';
  public minLevel: LogLevel = LogLevel.DEBUG;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  log(entry: LogEntry): void {
    if (!isPlatformBrowser(this.platformId)) {
      // Use Node.js console for server-side
      this.logToNodeConsole(entry);
      return;
    }

    // Browser console with structured format
    this.logToBrowserConsole(entry);
  }

  private logToNodeConsole(entry: LogEntry): void {
    const timestamp = new Date(entry.timestamp).toISOString();
    const level = LogLevel[entry.level].padEnd(5);
    const context = entry.platform === 'server' ? 'SSR' : 'CSR';
    const requestId = LogFormatterUtil.getRequestIdFromSession(entry.sessionId, entry.platform, 'ssr001');
    const source = entry.source || 'System';

    console.log(`[${timestamp}] ${level} | ${context} | req:${requestId} | ${source} | ${entry.message}`);

    if (entry.context) {
      LogFormatterUtil.logContextTree(entry.context);
    }

    if (entry.errorStack) {
      console.log('└─ Stack:', entry.errorStack);
    }
    
    console.log(''); // Add newline after log entry
  }

  private logToBrowserConsole(entry: LogEntry): void {
    const timestamp = new Date(entry.timestamp).toISOString();
    const level = LogLevel[entry.level].padEnd(5);
    const context = entry.platform === 'server' ? 'SSR' : 'CSR';
    const requestId = LogFormatterUtil.getRequestIdFromSession(entry.sessionId, entry.platform, 'ssr001');
    const source = entry.source || 'System';

    const logMessage = `[${timestamp}] ${level} | ${context} | req:${requestId} | ${source} | ${entry.message}`;
    
    // Log with appropriate console method and styling
    switch (entry.level) {
      case LogLevel.DEBUG:
        console.debug(`%c${logMessage}`, 'color: #B0BEC5;');
        break;
      case LogLevel.INFO:
        console.info(`%c${logMessage}`, 'color: #64B5F6;');
        break;
      case LogLevel.WARN:
        console.warn(`%c${logMessage}`, 'color: #FFB74D;');
        break;
      case LogLevel.ERROR:
      case LogLevel.CRITICAL:
        console.error(`%c${logMessage}`, 'color: #EF5350;');
        break;
    }

    if (entry.context) {
      LogFormatterUtil.logContextTree(entry.context);
    }

    if (entry.errorStack) {
      console.log('└─ Stack:', entry.errorStack);
    }
    
    console.log(''); // Add newline after log entry
  }

}
